import { useOutletContext } from 'react-router-dom';
import Header from './header';
import Footer from './footer';

const Login = () => {
  const { onLogin } = useOutletContext();
  
  return (
    <div className="App">
      <div className="mt-6 text-center">
        <Header />
        <button
          style={{
            borderRadius: '10px',
            backgroundColor: '#00053E',
            color: '#FFC72C',
            padding: '15px 30px',
            marginBottom: '20px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '18px'
          }}
          onClick={onLogin}
        >
          Login
        </button>
        <Footer />
      </div>
    </div>
  );
};

export default Login;